import axios from 'axios';

/** `{ [tableKey]: { [columnKey]: number } }`. Stored server-side as an opaque blob. */
export type ColumnWidthsMap = Record<string, Record<string, number>>;

const PATH = '/reporting-2.0/column-widths';

export const getColumnWidths = async (): Promise<ColumnWidthsMap> => {
  const response = await axios.get(PATH);
  return (response.data?.data?.widths ?? {}) as ColumnWidthsMap;
};

export const putTableColumnWidths = async (
  tableKey: string,
  widths: Record<string, number>,
): Promise<ColumnWidthsMap> => {
  const response = await axios.put(`${PATH}/${tableKey}`, { widths });
  return (response.data?.data?.widths ?? {}) as ColumnWidthsMap;
};
